import React from 'react';
import { useTranslation } from 'react-i18next';
import CareIcon from '@/comp/common/icons/CareIcon';
import * as S from '../widgets.styles';

/**
 * Package CARE icon with text
 */
const PackageCareIcon: React.FC = () => {
  const { t } = useTranslation();

  return (
    <S.HeaderSuffixIconContainer>
      <CareIcon width={16} height={16} />
      <S.HeaderSuffixIconText>
        {t('packageCare')}
        <span className="tm-text">™</span>
      </S.HeaderSuffixIconText>
    </S.HeaderSuffixIconContainer>
  );
};

PackageCareIcon.displayName = 'PackageCareIcon';

export default PackageCareIcon;
